var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66016 6.74483V9.34004H10.2554L15.7505 3.93481C16.0802 3.6101 16.0827 3.07974 15.7555 2.75252L14.2468 1.24386C13.9196 0.916644 13.3884 0.919142 13.0646 1.24885L7.66016 6.74483Z",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33039 9.34009H2.6652C1.74518 9.34009 1 10.0853 1 11.0053V11.0053C1 11.9253 1.74518 12.6705 2.6652 12.6705H14.3216C15.2416 12.6705 15.9868 13.4157 15.9868 14.3357V14.3357C15.9868 15.2557 15.2416 16.0009 14.3216 16.0009H10.9912",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTextIcon);
export default __webpack_public_path__ + "static/media/edit-text-icon.36d9749ce8c4a59e875373ec4631e90c.svg";
export { ForwardRef as ReactComponent };